// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul.dirinit[data-v-5a7b73b8]{list-style-type:none;padding:0!important}ul.dirinit li[data-v-5a7b73b8]{line-height:50px}ul.dirinit li img[data-v-5a7b73b8]{margin-right:10px}.card-body>img[data-v-5a7b73b8]{margin-bottom:25px!important}.dirinit h3[data-v-5a7b73b8]{color:#464646;font-weight:300}ul.dirinit li[data-v-5a7b73b8]{color:#494949!important;font-weight:400!important;line-height:45px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
